// Rótulos dos tipos de ocorrência (espelham o backend enums.py).
export const EEZYGUARD_TYPE_LABELS: Record<string, string> = {
  assedio_moral: 'Assédio moral',
  assedio_sexual: 'Assédio sexual',
  discriminacao: 'Discriminação',
  racismo: 'Racismo',
  intolerancia_religiosa: 'Intolerância religiosa',
  lgbtfobia: 'LGBTfobia',
  violencia_ameaca: 'Violência ou ameaça',
  retaliacao: 'Retaliação',
  fraude: 'Fraude',
  corrupcao: 'Corrupção',
  conflito_interesses: 'Conflito de interesses',
  conduta_antietica: 'Conduta antiética',
  seguranca_trabalho: 'Segurança do trabalho',
  descumprimento_normas: 'Descumprimento de normas',
  outras_ocorrencias: 'Outras ocorrências',
};
